import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BookMarkService } from 'src/app/modules/map/services/Bookmark/book-mark.service';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
import { SideNavService } from 'src/app/modules/map/services/sidenav/side-nav.service';



@Component({
  selector: 'app-rename-modal',
  templateUrl: './rename-modal.component.html',
  styleUrls: ['./rename-modal.component.css']
})
export class RenameModalComponent implements OnInit {
  reBookMark: any
  value: any
  id: any
  title: any
  subText: any
  type: any;
  bookmark_rename: any
  constructor(private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private mapService: MapServiceService,
    public bookMarkService: BookMarkService,
    private sideNavService: SideNavService) {

    //
  }

  ngOnInit(): void {
    this.bookmark_rename = this.mapService.getAllModals.bookmark_rename

    this.value = this.data.value
    this.id = this.data.id
    this.title = this.data.title
    this.subText = this.data.subTitle
    this.type = this.data.type
  }

  close(): void {
    this.dialog.closeAll()
  }
  save() {
    const body = {
      view_label: this.value,
      view_id: this.id
    };
    this.bookMarkService.renamebookMark(body).subscribe(res => {
      this.dialog.closeAll()
      this.sideNavService.reNameBookMarkData(
        this.reBookMark = res.bookmark
      );


    })


  }

}
